import { animate, AnimationBuilder, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { ExerciseService } from 'app/shared/services/exercises.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Category } from '../../shared/models/Category';
import { Exercise } from '../../shared/models/Exercises';
import { BoxComponent } from '../../theme/components/box/box.component';
import { VideoDialogComponent } from '../../theme/components/videoDialog/videoDialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ex',
  templateUrl: './ex.component.html',
  styleUrls: ['./ex.component.scss'],
  animations: [
    trigger('box', [
      transition(':leave', [
        style({ opacity: '1', width: '*', overflow: 'hidden' }),
        animate('.3s ease-in-out', style({ opacity: '0', width: '0', overflow: 'hidden' })),
      ]),
      transition('*=>*', [
        style({ opacity: '0' }),
        animate(
          '.3s .3s ease-in-out',
          keyframes([style({ opacity: '0', offset: 0 }), style({ opacity: '1', offset: 1 })])
        ),
      ]),
    ]),
  ],
})
export class ExComponent implements OnDestroy {
  public exercises: Exercise[];
  public filterargs: any;
  mainCategories: Category[] = [];
  selected: string = 'true';
  color: string;

  public displaySalmagundiIndicator = false;

  public completedSalmagundiExerciseIds = [];

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public displayCategories = true;

  @ViewChildren(BoxComponent, { read: ElementRef }) boxes: QueryList<ElementRef>;

  public constructor(
    private exerciseService: ExerciseService,
    private challengeService: ChallengeService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private builder: AnimationBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.displayCategories = true;
    this.exerciseService.getAllExercises().then((exercises) => (this.exercises = exercises));
    this.exerciseService.getMainCategories().then((categories) => (this.mainCategories = categories));

    // Find out whether salmagundi bonus indicator should be displayed
    combineLatest(this.challengeService.displayedChallenge, this.challengeService.team, this.challengeService.teamUser)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(([challenge, team, user]) => {
        if (
          // If a challenge is currently running and the user is member of a team
          challenge &&
          moment(challenge.start).isBefore(moment()) &&
          moment(challenge.end).isAfter(moment()) &&
          user &&
          user.membershipStatus === 'member' &&
          team &&
          team.userGroups.members.length >= challenge.minimalTeamMembers
        ) {
          this.displaySalmagundiIndicator = true;
        } else {
          this.displaySalmagundiIndicator = false;
        }

        if (user && user.bonuses && user.bonuses.salmagundi && user.bonuses.salmagundi.exerciseIDs) {
          this.completedSalmagundiExerciseIds = user.bonuses.salmagundi.exerciseIDs;
        } else {
          this.completedSalmagundiExerciseIds = [];
        }
      });

    // check for query params and set filter: only relevant for kids modules
    this.activatedRoute.queryParams.subscribe((params) => {
      const categoryId = params['category'];

      if (categoryId) {
        this.filterargs = categoryId;
        this.displayCategories = false;
      }
    });
  }

  openVideoDialog(ex: Exercise): void {
    const dialogRef = this.dialog.open(VideoDialogComponent, {
      panelClass: 'app-video-dialog-container',
      // width: '60vw',
      maxWidth: '2600px',
      position: {
        top: '5vh',
      },
      data: { exercise: ex },
    });

    dialogRef
      .afterClosed()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {
        console.log('The dialog was closed');
      });
  }

  filter(cat?: Category) {
    this.filterargs = null;
    if (cat) {
      this.filterargs = cat._id;
    }
  }

  refs: { el: ElementRef; rect: any }[] = [];

  boxChanges(list: QueryList<ElementRef>) {
    if (list) {
      this.refs = [];
    }

    list.forEach((item) => {
      this.refs.push({
        el: item,
        rect: item.nativeElement.getBoundingClientRect(),
      });
    });

    this.requestedAnimation();
  }

  requestedAnimation() {
    requestAnimationFrame(() => {
      for (let item of this.refs) {
        let domNode = item.el.nativeElement;

        const newBox = domNode.getBoundingClientRect();
        const oldBox = item.rect;

        const deltaX = oldBox.left - newBox.left;
        const deltaY = oldBox.top - newBox.top;

        // first build the animation
        const myAnimation = this.builder.build([
          style({ transform: `translate(${deltaX}px, ${deltaY}px)` }),
          animate('.2s ease-in-out', style({ transform: 'translate(0, 0)' })),
        ]);

        // then create a player from it
        const player = myAnimation.create(item.el.nativeElement);

        player.play();
      }
    });
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/exercises/ex.component.ts